import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";

@Component({
  selector: "app-ic-cancel-sidenav",
  templateUrl: "./ic-cancel-sidenav.component.html",
})
export class IcCancelSidenavComponent implements OnInit {
  tcCode = "";
  currentURL = "";

  constructor(private router: Router) {}

  ngOnInit() {
    if (localStorage.getItem("testCode") != null) {
      this.tcCode = localStorage.getItem("testCode");
    }
    this.checkURL("physician-information");
  }

  checkURL(type) {
    sessionStorage.setItem("type", type);
    if (type != null && localStorage.getItem("testCode") != null) {
      if (this.router.url) {
        const url = this.router.url.toString().trim().split("/");
        this.currentURL = url[2];
      }
      if (!this.router.url) {
        setTimeout(() => {
          const url = this.router.url.toString().trim().split("/");
          this.currentURL = url[1];
        }, 100);
      }
    }
  }
}
